import { Icon } from '../../../../../../../../components/icon';
import { Button } from '../../../../../../../../components/shadcn/button';
import { cn } from '../../../../../../../../lib/utils';

export interface PlaybackState {
  isPlaying: boolean;
  currentTime: number;
  duration: number;
  playbackRate: number;
}

export interface PlaybackController {
  state: PlaybackState;
  audioRef: React.RefObject<HTMLAudioElement>;
  togglePlayPause: () => void;
  seekTo: (time: number) => void;
  skipForward: (seconds?: number) => void;
  skipBackward: (seconds?: number) => void;
  setPlaybackRate: (rate: number) => void;
  getCurrentProgress: () => number;
}

export function PlaybackControls({ playbackController }: { playbackController: PlaybackController }) {
  return (
    <div className="flex items-center gap-1.5">
      {/* View toggle button */}

      <Button onClick={playbackController.togglePlayPause}>
        <Icon className={cn(playbackController.state.isPlaying ? 'lucide--pause' : 'lucide--play')} />
        <span>{playbackController.state.isPlaying ? 'Pause' : 'Play'} Transcript</span>
      </Button>

      {playbackController && <audio ref={playbackController.audioRef} preload="metadata" crossOrigin="anonymous" />}
    </div>
  );
}
